module.exports = __webpack_public_path__ + "static/img/cc.ce8705c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/cc.png
// module id = X/tS
// module chunks = 0